import { createFileRoute } from '@tanstack/react-router';

import { BriefPage } from '../../../../features/estimates/ui/brief-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id_/brief')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: BriefRoute,
});

/** Бриф сделки на всю страницу: `/sales/deals/<id>/brief`. */
function BriefRoute() {
  const { id } = Route.useParams();
  return <BriefPage dealId={id} />;
}
